import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { DropDownFormControl } from './dropdown-form-control';

@Component({
    selector: 'app-dropdown-form-control',
    templateUrl: './dropdown-form-control.component.html',
})
export class DropDownFormControlComponent extends AbstractFormControlComponent<DropDownFormControl> {
    @Output() onChange: EventEmitter<any> = new EventEmitter();
    @Input() parentForm: FormGroup;
    @Input() title: string;
    @Input() controlName: string;
    @Input() floatLabel: string;
    @Input() placeholder: string;
    @Input() inline: boolean;

    faCheck: any = faCheck;
    faClose: any = faTimes;

    change(value: any): void {
        this.onChange.emit(value);
    }

    selectOpened(value: any): void {
        if (value !== 0) {
            this.collection.forEach((element) => {
                if (element[this.keyPropertyName] === value) {
                    document.querySelectorAll('.dropdown-item-class').forEach((item) => {
                        if (item.getAttribute('id') === value.toString()) {
                            item.scrollIntoView({ block: 'center', behavior: 'smooth' });
                        }
                    });
                }
            });
        }
    }

    public get isInline(): boolean {
        return this.inline || false;
    }

    public get placeholderText(): string {
        return this.placeholder || '';
    }

    public get floatLabelText(): string {
        return this.floatLabel || 'never';
    }

    public get readOnlyCss(): boolean {
        return this.control.readOnlyCss || false;
    }

    public get hideSuccessMark(): boolean {
        return this.control.hideSuccessMark || false;
    }

    public get collection(): any[] {
        return this.control.collection || [];
    }

    public get hiddenOptions(): any[] {
        return this.control.hiddenOptions || [];
    }

    public get keyPropertyName(): string {
        return this.control.keyPropertyName || 'name';
    }

    public get valuePropertyName(): string {
        return this.control.valuePropertyName || 'name';
    }

    public get disableChooseOption(): boolean {
        return this.control.disableChooseOption || false;
    }

    public get hideErrorMessages(): boolean {
        return this.control.hideErrorMessages || false;
    }

    public get hideErrorMark(): boolean {
        return this.control.hideErrorMark || true;
    }
    public get matOptionAutoHeight(): boolean {
        return this.control.matOptionAutoHeight || false;
    }
}
